import { render, staticRenderFns } from "./actBanner.vue?vue&type=template&id=c5e3c7ce&scoped=true&"
import script from "./actBanner.vue?vue&type=script&lang=js&"
export * from "./actBanner.vue?vue&type=script&lang=js&"
import style0 from "./actBanner.vue?vue&type=style&index=0&id=c5e3c7ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e3c7ce",
  null
  
)

export default component.exports